"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicIdT = exports.TopicId = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * A `TopicId` identifies an application-specific category of data. Because it
 * is application-specific, it is up to the application within the specified
 * organization to define its semantics/meaning.
 *
 * For example, "bob" may have an "overlay" app with a "settings" topic for controlling
 * the overlay visibility and other settings, as well as a "video feed" topic for
 * allowing other applications to display video data in a wrist mounted window in VR.
 */
class TopicId {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTopicId(bb, obj) {
        return (obj || new TopicId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTopicId(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TopicId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    organization(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    appName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    topic(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startTopicId(builder) {
        builder.startObject(3);
    }
    static addOrganization(builder, organizationOffset) {
        builder.addFieldOffset(0, organizationOffset, 0);
    }
    static addAppName(builder, appNameOffset) {
        builder.addFieldOffset(1, appNameOffset, 0);
    }
    static addTopic(builder, topicOffset) {
        builder.addFieldOffset(2, topicOffset, 0);
    }
    static endTopicId(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTopicId(builder, organizationOffset, appNameOffset, topicOffset) {
        TopicId.startTopicId(builder);
        TopicId.addOrganization(builder, organizationOffset);
        TopicId.addAppName(builder, appNameOffset);
        TopicId.addTopic(builder, topicOffset);
        return TopicId.endTopicId(builder);
    }
    unpack() {
        return new TopicIdT(this.organization(), this.appName(), this.topic());
    }
    unpackTo(_o) {
        _o.organization = this.organization();
        _o.appName = this.appName();
        _o.topic = this.topic();
    }
}
exports.TopicId = TopicId;
class TopicIdT {
    constructor(organization = null, appName = null, topic = null) {
        this.organization = organization;
        this.appName = appName;
        this.topic = topic;
    }
    pack(builder) {
        const organization = (this.organization !== null ? builder.createString(this.organization) : 0);
        const appName = (this.appName !== null ? builder.createString(this.appName) : 0);
        const topic = (this.topic !== null ? builder.createString(this.topic) : 0);
        return TopicId.createTopicId(builder, organization, appName, topic);
    }
}
exports.TopicIdT = TopicIdT;
